import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "info-outline",
  class: "row col-xs-12 items-center"
}
const _hoisted_2 = { class: "row justify-start col-xs-11" }
const _hoisted_3 = { class: "col-xs-12 col-md-6 s-form-input_wrapper wrap-anyway" }
const _hoisted_4 = { class: "col-xs-12 col-md-6 s-form-input_wrapper wrap-anyway" }
const _hoisted_5 = { class: "col-xs-1 text-center" }

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import SInput from 'SharedComponents/ui/Input/SInput.vue';
import useValidation from 'SharedDir/common/composables/useValidation';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';

import HeaderCell from './header-cell';

export interface Props extends PropValue<null | HeaderCell> {
  readonly?: boolean;
  maxColspan: number;
}

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'HeaderCellItem',
},
  __name: 'HeaderCell',
  props: {
    readonly: { type: Boolean, default: false },
    maxColspan: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits, {
  transform: (v) => v ?? new HeaderCell(),
});
const { NotEmpty, GreaterThenOrEqual, LessThenOrEqual } = useValidation();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SInput, {
          modelValue: _unref(innerValue).label,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue).label) = $event)),
          class: "s-form-input required",
          clearable: "",
          outlined: "",
          dense: "",
          required: "",
          "hide-bottom-space": "",
          label: "Заголовок столбца",
          name: "label",
          readonly: _ctx.readonly,
          rules: [_unref(NotEmpty)('Заголовок обязателен для заполнения')],
          onBlur: _unref(emitValue)
        }, null, 8, ["modelValue", "readonly", "rules", "onBlur"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SInput, {
          modelValue: _unref(innerValue).colspan,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).colspan) = $event)),
          modelModifiers: { number: true },
          class: "s-form-input required",
          clearable: "",
          outlined: "",
          dense: "",
          required: "",
          type: "number",
          "hide-bottom-space": "",
          label: "Colspan",
          name: "slug",
          readonly: _ctx.readonly,
          rules: [
            _unref(NotEmpty)('Colspan обязателен для заполнения'),
            _unref(GreaterThenOrEqual)(1),
            _unref(LessThenOrEqual)(_ctx.maxColspan),
          ],
          onBlur: _unref(emitValue)
        }, null, 8, ["modelValue", "readonly", "rules", "onBlur"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(SBtn, {
        type: "icon",
        icon: "las la-trash-alt",
        tooltip: "Удаление столбца",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.readonly && _ctx.$emit('remove')))
      })
    ])
  ]))
}
}

})